/*
  Free gifts: keeps the gift products (cart drawer setting "Free gifts") in the cart while the
  trigger product is in it, 1 of each, and removes them when it isn't.

  Works by wrapping window.fetch: after any /cart/add, /cart/change or /cart/update request
  succeeds, the cart is checked and fixed with one /cart/update.js call. When the original request
  asked for re-rendered sections, the fix asks for the same sections and they replace the original
  ones in the response, so the theme renders the drawer once with the gifts already in it.
*/
(function () {
  if (window.__yumFreeGifts) return;
  window.__yumFreeGifts = true;

  var nativeFetch = window.fetch.bind(window);

  function config() {
    var el = document.getElementById('FreeGiftConfig');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent);
      return c.enabled && c.trigger && c.gifts && c.gifts.length ? c : null;
    } catch (e) {
      return null;
    }
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
  }

  function requestedSections(body) {
    try {
      if (!body) return {};
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return { sections: body.get('sections'), sections_url: body.get('sections_url') };
      }
      if (body instanceof URLSearchParams) {
        return { sections: body.get('sections'), sections_url: body.get('sections_url') };
      }
      if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') {
          var j = JSON.parse(body);
          return { sections: j.sections, sections_url: j.sections_url };
        }
        var p = new URLSearchParams(body);
        return { sections: p.get('sections'), sections_url: p.get('sections_url') };
      }
    } catch (e) {}
    return {};
  }

  // Quantities the gift variants should change to, or null when the cart is already right.
  async function giftUpdates(conf) {
    var cart = await (await nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    // Gifts come with the subscription only (a one-time purchase of the same product gets none)
    var hasTrigger = cart.items.some(function (i) { return i.product_id === conf.trigger && i.selling_plan_allocation; });
    var updates = {};
    var changed = false;
    conf.gifts.forEach(function (variantId) {
      var qty = cart.items
        .filter(function (i) { return i.variant_id === variantId; })
        .reduce(function (sum, i) { return sum + i.quantity; }, 0);
      var want = hasTrigger ? 1 : 0;
      if (qty !== want) {
        updates[variantId] = want;
        changed = true;
      }
    });
    return changed ? updates : null;
  }

  async function applyUpdates(updates, sections, sectionsUrl) {
    var body = { updates: updates };
    if (sections) {
      body.sections = sections;
      body.sections_url = sectionsUrl || window.location.pathname;
    }
    var res = await nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    return res.json();
  }

  window.fetch = async function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var res = await nativeFetch(input, init);
    var conf = isCartMutation(url) && res.ok ? config() : null;
    if (!conf) return res;
    try {
      var updates = await giftUpdates(conf);
      if (!updates) return res;
      var req = requestedSections(init && init.body);
      var fixed = await applyUpdates(updates, req.sections, req.sections_url);
      var original = await res.clone().json();
      var merged = original;
      if (original && Array.isArray(original.items) && 'item_count' in original) {
        // Cart-shaped response (/cart/change, /cart/update): use the fixed cart
        merged = Object.assign({}, original, fixed);
      }
      if (fixed.sections) merged.sections = fixed.sections;
      return new Response(JSON.stringify(merged), {
        status: res.status,
        statusText: res.statusText,
        headers: { 'Content-Type': 'application/json' },
      });
    } catch (e) {
      console.warn('[free gifts]', e);
      return res;
    }
  };

  // On page load: fix a cart that is out of sync (e.g. built before the gifts existed).
  async function syncOnLoad() {
    var conf = config();
    if (!conf) return;
    try {
      var updates = await giftUpdates(conf);
      if (!updates) return;
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender
        ? drawer.getSectionsToRender().map(function (s) { return s.id; })
        : null;
      var fixed = await applyUpdates(updates, sections, window.location.pathname);
      if (drawer && drawer.renderContents && fixed.sections) drawer.renderContents(fixed);
    } catch (e) {
      console.warn('[free gifts]', e);
    }
  }

  // Shopify lists the newest lines first, so the gifts would sit above the product: move them last.
  function giftsLast() {
    document.querySelectorAll('cart-drawer tbody').forEach(function (body) {
      var gifts = body.querySelectorAll(':scope > tr[data-free-gift]');
      if (!gifts.length) return;
      var rows = body.querySelectorAll(':scope > tr');
      var lastRows = Array.prototype.slice.call(rows, rows.length - gifts.length);
      var alreadyLast = lastRows.every(function (r) { return r.hasAttribute('data-free-gift'); });
      if (!alreadyLast) gifts.forEach(function (g) { body.appendChild(g); });
    });
  }

  function start() {
    giftsLast();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(giftsLast).observe(drawer, { childList: true, subtree: true });
    syncOnLoad();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
